import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPostgresIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 48,
			height: 48,
			rx: 8,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.4351 29.4714C29.5879 28.1996 29.5421 28.0131 30.4904 28.2191L30.7311 28.2403C31.4603 28.2734 32.4141 28.1231 32.9745 27.863C34.1808 27.3039 34.8961 26.3704 33.7066 26.6157C30.9934 27.1748 30.8069 26.2571 30.8069 26.2571C33.6719 22.0107 34.8695 16.6203 33.8358 15.3008C31.0161 11.7018 26.1353 13.4037 26.0537 13.4479L26.0277 13.4527C25.4916 13.3416 24.8916 13.2752 24.2176 13.2643C22.9898 13.2442 22.0581 13.5858 21.3514 14.1213C21.3514 14.1213 12.6444 10.538 13.0495 18.6277C13.1356 20.3486 15.5189 31.6496 18.3614 28.2362C19.4003 26.988 20.4043 25.9326 20.4043 25.9326C20.9028 26.2635 21.4997 26.4323 22.1257 26.3716L22.1741 26.3304C22.159 26.4854 22.1657 26.637 22.1935 26.8164C21.4614 27.6337 21.6765 27.7772 20.2125 28.0782C18.7314 28.3832 19.6015 28.9261 20.1695 29.0679C20.8583 29.24 22.4516 29.4837 23.5285 27.9781L23.4856 28.1499C23.7729 28.3795 23.7534 29.7999 23.7942 30.8147C23.835 31.8296 23.903 32.7767 24.1101 33.335C24.3172 33.8933 24.5615 35.3315 26.4856 34.9196C28.0936 34.5754 29.323 34.08 29.4351 29.4714Z",
			fill: "black",
			stroke: "black",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.7068 26.6157C30.9933 27.1748 30.8068 26.257 30.8068 26.257C33.6718 22.0104 34.8694 16.6199 33.8359 15.3006C31.0162 11.7018 26.1352 13.4038 26.0538 13.448L26.0276 13.4527C25.4915 13.3415 24.8915 13.2753 24.2172 13.2643C22.9894 13.2442 22.058 13.5858 21.3513 14.1212C21.3513 14.1212 12.6441 10.538 13.0491 18.6277C13.1352 20.3487 15.5184 31.6497 18.361 28.2362C19.4 26.9881 20.4038 25.9327 20.4038 25.9327C20.9024 26.2636 21.4993 26.4323 22.1251 26.3717L22.1737 26.3305C22.1586 26.4855 22.1655 26.6371 22.1932 26.8165C21.4609 27.6338 21.6761 27.7773 20.2122 28.0783C18.7309 28.3832 19.6011 28.9261 20.1692 29.068C20.858 29.2401 22.4515 29.4838 23.5281 27.9782L23.4852 28.15C23.7721 28.3796 23.9736 29.6433 23.9398 30.7888C23.9061 31.9343 23.8835 32.7208 24.1096 33.3351C24.3357 33.9494 24.561 35.3316 26.4854 34.9197C28.0934 34.5755 28.9267 33.6834 29.0426 32.1955C29.1249 31.1376 29.311 31.294 29.3228 30.3483L29.4721 29.9005C29.6443 28.4665 29.4995 28.0039 30.4902 28.2191L30.7309 28.2402C31.4601 28.2734 32.4144 28.1231 32.9745 27.863C34.1806 27.3039 34.8959 26.3704 33.7067 26.6157H33.7068Z",
			fill: "#336791"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.6446 27.4375C23.5699 30.1057 23.6634 32.7925 23.9248 33.4455C24.1863 34.0985 24.746 35.3686 26.6705 34.9568C28.2784 34.6124 28.8634 33.9461 29.1173 32.4753C29.3042 31.3931 29.6647 28.3878 29.7109 27.772",
			stroke: "white",
			strokeWidth: .7,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.338 14.0614C21.338 14.0614 12.6249 10.5041 13.0299 18.5937C13.1161 20.3147 15.4994 31.6161 18.342 28.2025C19.3807 26.9542 20.3202 25.9751 20.3202 25.9751",
			stroke: "white",
			strokeWidth: .7,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.0443 13.4123C25.7427 13.5067 30.8911 11.5322 33.8169 15.2669C34.8505 16.5862 33.6528 21.9767 30.7878 26.2235",
			stroke: "white",
			strokeWidth: .7,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.7877 26.2234C30.7877 26.2234 30.9744 27.1414 33.688 26.5819C34.8769 26.3366 34.1614 27.2702 32.9556 27.8296C31.966 28.2884 29.7473 28.406 29.7111 27.772C29.6178 26.1363 30.8787 26.6332 30.7877 26.2234ZM30.7877 26.2234C30.7055 25.8543 30.1416 25.492 29.7686 24.5886C29.4429 23.8001 25.3022 17.7532 30.9169 18.6512C31.1226 18.6087 29.4525 13.3164 24.198 13.2303C18.9446 13.1443 19.117 19.6839 19.117 19.6839",
			stroke: "white",
			strokeWidth: .7,
			strokeLinecap: "round",
			strokeLinejoin: "bevel"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.1741 26.7828C21.4417 27.6001 21.6571 27.7436 20.1931 28.0447C18.7119 28.3497 19.5821 28.8925 20.1501 29.0343C20.8389 29.2065 22.4323 29.4502 23.509 27.9443C23.8369 27.4857 23.5071 26.7541 23.0567 26.5676C22.8391 26.4776 22.5481 26.3647 22.1741 26.7828Z",
			stroke: "white",
			strokeWidth: .7,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.1261 26.7685C22.0523 26.288 22.2841 25.7163 22.5326 25.0473C22.906 24.0436 23.7676 23.0398 23.0784 19.856C22.5647 17.4834 19.1191 19.3622 19.1169 19.6839C19.1148 20.0055 19.2728 21.3145 19.0594 22.8388C18.7809 24.8279 20.3264 26.5102 22.1061 26.3381",
			stroke: "white",
			strokeWidth: .7,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.3063 19.6356C21.2908 19.7455 21.5077 20.0387 21.7905 20.0778C22.0729 20.1172 22.3145 19.888 22.3299 19.7783C22.3452 19.6684 22.1285 19.5474 21.8456 19.508C21.5631 19.4687 21.3213 19.526 21.3064 19.6356H21.3063Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.9062 19.4117C29.9216 19.5216 29.7049 19.8148 29.422 19.8539C29.1395 19.8933 28.8978 19.6641 28.8823 19.5544C28.8674 19.4445 29.0841 19.3235 29.3667 19.2841C29.6493 19.2448 29.8909 19.3021 29.9062 19.4117V19.4117Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.9169 18.6514C30.9634 19.5132 30.731 20.1003 30.7018 21.0177C30.6584 22.3513 31.3382 23.8777 30.3138 25.4059",
			stroke: "white",
			strokeWidth: .7,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgPostgresIcon;
